<template>
  <div>
    <el-container>
      <el-aside style="width: 200px;">
        <Menu activeName="3-2"></Menu>
      </el-aside>
      <el-main style="display: flex;flex: 1;padding: 0;flex-direction: row;height: 100vh;">
        <div style="display: flex;flex-direction: column;width: 320px;margin:20px;">
          <div style="height: 100%;display: flex;flex-direction: column;" v-if="status == 0">
            <el-button @click="newRoute" type="primary" icon="el-icon-circle-plus" size="medium">新建路线</el-button>
            <div class="route-list">
              <el-collapse v-model="collapseIndex">
                <el-collapse-item v-for="(item, index) in routes" :key="item.id" :name="index">
                  <template slot="title">
                    <i class="el-icon-truck" style="color: #409EFF;font-size: 20px;"></i>
                    <div style="font-size: 16px;margin-left: 12px;">{{ item.username }}</div>
                  </template>
                  <div style="display: flex;flex-direction: row;align-items: center;margin: 10px 0;">
                    <i v-if="routeConf.showPlaceIndex == index" class="el-icon-caret-bottom"
                      style="padding: 12px;font-size: 18px;" @click="routeConf.showPlaceIndex = null;"></i>
                    <i v-else class="el-icon-caret-right" style="padding: 12px;font-size: 18px;"
                      @click="routeConf.showPlaceIndex = index; routeConf.index = index;"></i>
                    <div :class="[routeConf.index == index ? 'route-choose' : 'route-not-choose']" class="route-info"
                      @click="chooseRoute(index)">
                      <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
                        <div style="font-size: 16px;color: #333;">{{ item.name }}</div>
                        <div style="display: flex;flex-direction: row;align-items: center;">
                          <el-dropdown trigger="click" @command="handleCommand">
                            <el-button type="text" style="font-size: 12px;" @click.stop="">操作</el-button>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :command="commandValue('update', index)">修改</el-dropdown-item>
                              <el-dropdown-item :command="commandValue('delete', index)">删除</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                          <el-popover placement="right" width="160" trigger="manual"
                            :value="popoverConf.route_id == item.id && popoverConf.visible">
                            <el-select size="small" v-model="popoverConf.user_id" filterable placeholder="请选择配送司机">
                              <el-option v-for="item in userList" :key="item.id" :label="item.username" :value="item.id">
                              </el-option>
                            </el-select>
                            <div style="text-align: right; margin-top: 12px;">
                              <el-button size="mini" type="text"
                                @click="popoverConf.route_id = null; popoverConf.visible = false">取消</el-button>
                              <el-button type="primary" size="mini" @click="setRouteUser()">确定</el-button>
                            </div>
                            <el-button slot="reference" type="text" style="font-size: 12px;margin-left: 8px;"
                              @click.stop="showUserPopover(index)">更换司机
                            </el-button>
                          </el-popover>
                        </div>
                      </div>
                      <div style="display: flex;flex-direction: row;flex-wrap: wrap;margin-top: 8px;font-size: 14px;">
                        <div style="padding-right: 10px;color: #333;" v-for="(goodsInfo,goodsIndex) in routeGoods[index]" :key="goodsIndex">
                          <span>{{goodsInfo.name}}：{{goodsInfo.number}}</span>
                        </div>
                      </div>
                      <div style="font-size: 12px;color: #999;margin-top: 8px;">共计配送{{ routePlaces[index] ? routePlaces[index].length : ''
                      }}个地点
                      </div>
                      <div style="font-size: 12px;color: #808695;margin-top: 2px;">{{ item.create_time }}</div>
                    </div>
                  </div>
                  <div v-if="routeConf.showPlaceIndex == index" class="route-place-list-div">
                    <div class="route-form-label">排单门店</div>
                    <div class="route-place-list">
                      <el-card :body-style="{ 'border': 'none', 'padding': '8px 12px' }" class="box-card" shadow="none"
                        v-for="(place, index) in routePlaces[routeConf.showPlaceIndex]" v-bind:key="index">
                        <div style="display: flex;flex-direction: column;">
                          <span style="font-size: 14px;font-weight: 500;color: #333;">{{ place.name }}</span>
                          <span style="font-size: 12px;color: #666;margin-top: 2px;">{{ place.address }}</span>
                          <div style="display: flex;flex-direction: row;font-size: 12px;color: #666;margin-top: 4px;"
                            v-if="place.phone">
                            <span><i class="el-icon-phone"></i>{{ place.phone_name }}({{ place.phone }})</span>
                          </div>
                          <span style="font-size: 12px;color: #999;" v-if="place.remarks">备注：
                            {{ place.remarks }}</span>
                        </div>
                      </el-card>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>

          <div v-if="status == 2" style="display: flex;flex-direction: column;height: 100%;">
            <el-page-header @back="goBack" v-if="routeReq.id" content="编辑路线"></el-page-header>
            <el-page-header @back="goBack" v-else content="创建路线"></el-page-header>
            <div style="padding-top: 24px;display: flex;flex-direction: column;">
              <div>
                <div class="route-form-label">路线名称</div>
                <el-input v-model="routeReq.name" placeholder="请输入路线名称"></el-input>
              </div>
              <div style="margin-top: 24px;">
                <div class="route-form-label">配送司机</div>
                <el-select v-model="routeReq.user_id" filterable placeholder="请选择配送司机" style="width: 100%;">
                  <el-option v-for="item in userList" :key="item.id" :label="item.username" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-top: 24px;">
                <div class="route-form-label">商品统计</div>
                <div style="display: flex;flex-direction: row;flex-wrap: wrap;font-size: 14px;" v-if="routeReq.id">
                  <div style="padding-right: 10px;color: #333;" v-for="(goodsInfo,goodsIndex) in routeGoods[routeConf.index]" :key="goodsIndex">
                    <span>{{goodsInfo.name}}：{{goodsInfo.number}}</span>
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;flex-wrap: wrap;font-size: 14px;" v-else>
                  <div style="padding-right: 10px;color: #333;" v-for="(goodsInfo,goodsIndex) in newRouteGoods" :key="goodsIndex">
                    <span>{{goodsInfo.name}}：{{goodsInfo.number}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 24px;">
              <div class="route-form-label">排单门店</div>
            </div>
            <div v-if="routeReq.id" class="route-form-place-list">
              <el-card :body-style="{ 'border': 'none', 'padding': '8px 12px' }" class="box-card" shadow="none"
                       v-for="(place, index) in routeMarkers[routeConf.index]" v-bind:key="index">
                <div style="display: flex;flex-direction: column;">
                  <span style="font-size: 14px;font-weight: 500;color: #333;">{{ place.name }}</span>
                  <span style="font-size: 12px;color: #666;margin-top: 2px;">{{ place.address }}</span>
                  <div style="display: flex;flex-direction: row;font-size: 12px;color: #666;margin-top: 2px;"
                       v-if="place.phone">
                    <span><i class="el-icon-phone"></i>{{ place.phone_name }}({{ place.phone }})</span>
                  </div>
                  <span style="font-size: 12px;color: #999;" v-if="place.remarks">备注：
                    {{ place.remarks }}</span>
                </div>
              </el-card>
            </div>
            <div v-else>
              <el-cascader style="width: 100%;" @change="placeChangeHandle" v-model="placeIndexs"
                           :options="waypointConf.options" :props="waypointConf.props" filterable clearable collapse-tags>
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                </template>
              </el-cascader>
            </div>

            <el-button @click="submitRoute" type="primary"
              style="height: 40px;width: 280px;align-self: center;margin-top: 24px;">保 存
            </el-button>
          </div>
        </div>
        <div style="flex: 1;height: 100vh;">
          <el-amap vid="map" @init="initMap" style="flex: 1;" @click="clickMap">
            <el-amap-control-geolocation :visible="true" @complete="getLocation"></el-amap-control-geolocation>
            <el-amap-marker v-if="placeMarkers.length > 0" v-for="(item, index) in placeMarkers" :key="'place-' + index"
              :vid="'place-' + index" @click="markerClickHandle(index)" @mouseover="handleMouseOver(item.id, 2)"
              @mouseout="handleMouseLeave" anchor="center"
              :position="[item.locations.longitude, item.locations.latitude]">
              <div>
                <img v-if="placeIds.includes(item.id)" src="/static/images/index/marker-1.png" alt=""
                  style="width: 24px;height: 24px;">
                <img v-else src="/static/images/index/marker-2.png" alt="" style="width: 24px;height: 24px;">
              </div>
            </el-amap-marker>
            <template v-if="routeMarkers.length > 0" v-for="(markers, index) in routeMarkers">
              <el-amap-marker :zIndex="98" v-for="(markerItem, markerIndex) in markers"
                :key="'route-' + index + 'place-' + markerIndex" :vid="markerItem.location" anchor="center"
                :position="[markerItem.locations.longitude, markerItem.locations.latitude]"
                @mouseover="handleMouseOver(markerItem.id, 1)" @mouseout="handleMouseLeave">
                <div class="route-place-sort"
                  :style="{ 'background-color': routeConf.index == index ? routeMarkerConf.checked.bgColor : routeMarkerConf.unchecked.bgColor }">
                  {{ markerIndex + 1 }}
                </div>
              </el-amap-marker>
            </template>

            <el-amap-info-window v-if="placeMarkers.length > 0" v-for="(item, index) in placeMarkers"
              :key="'place-window-' + index" :closeWhenClickMap="true"
              :position="[item.locations.longitude, item.locations.latitude]" :autoMove="false" :offset="[0, -20]"
              anchor="bottom-center" :visible="item.id == overConf.placeId">
              <div style="display: flex;flex-direction: column;padding:4px;margin-top: 4px;">
                <div style="font-size: 16px;color: #333;font-weight: 500">{{ item.name }}</div>
                <div style="font-size: 14px;color: #999;margin-top: 2px;">{{ item.address }}</div>
                <div style="font-size: 14px;color: #666;margin-top: 4px;">
                  <span v-if="item.phone_name">客户：{{ item.phone_name }}</span>
                  <span v-if="item.phone">电话：{{ item.phone }}</span>
                </div>
                <div style="font-size: 14px;color: #333;margin-top: 4px;" v-if="item.remarks">{{ item.remarks }}</div>
              </div>
            </el-amap-info-window>
            <template v-if="routeMarkers.length > 0" v-for="(markers, index) in routeMarkers">
              <el-amap-info-window v-for="(item, markerIndex) in markers"
                :key="'route-' + index + '-place-window-' + markerIndex" :closeWhenClickMap="true"
                :position="[item.locations.longitude, item.locations.latitude]" :autoMove="false" :offset="[0, -20]"
                anchor="bottom-center" :visible="item.id == overConf.routePlaceId">
                <div style="display: flex;flex-direction: column;padding:4px;margin-top: 4px;">
                  <div style="font-size: 16px;color: #333;font-weight: 500">{{ item.name }}</div>
                  <div style="font-size: 14px;color: #999;margin-top: 2px;">{{ item.address }}</div>
                  <div style="font-size: 14px;color: #666;margin-top: 4px;">
                    <span v-if="item.phone_name">客户：{{ item.phone_name }}</span>
                    <span v-if="item.phone">电话：{{ item.phone }}</span>
                  </div>
                  <div style="font-size: 14px;color: #333;margin-top: 4px;" v-if="item.remarks">{{ item.remarks }}</div>
                </div>
              </el-amap-info-window>
            </template>
            <template v-if="routePolygons.length > 0">
              <el-amap-polygon v-for="(polygon, index) in routePolygons" :key="'polygon-' + index" :path="polygon"
                :editable="false" :strokeOpacity="0"
                :strokeColor="routeConf.index == index ? routePolygonConf.checked.strokeColor : routePolygonConf.unchecked.strokeColor"
                :fillColor="routeConf.index == index ? routePolygonConf.checked.strokeColor : routePolygonConf.unchecked.strokeColor"
                :fillOpacity="routePolygonConf.fillOpacity"></el-amap-polygon>
            </template>

            <template v-if="routePolylines.length > 0">
              <el-amap-polyline v-for="(polyline, index) in routePolylines" :key="'polyline-' + index" :path="polyline"
                :editable="false"
                :strokeColor="routeConf.index == index ? routePolylineConf.checked.strokeColor : routePolylineConf.unchecked.strokeColor"
                :strokeWeight="routePolylineConf.strokeWeight" strokeStyle='solid' lineJoin="round" :showDir="true"
                :strokeOpacity="1"></el-amap-polyline>
            </template>

            <el-amap-marker v-if="routeCenterPoints.length > 0" :zIndex="99" v-for="(point, index) in routeCenterPoints"
              :key="'center-point-' + index" :vid="'center-point-' + index" :offset="[-20, -20]" anchor="center"
              :position="point" @click="chooseRoute(index)">
              <div :class="[routeConf.index == index ? 'route-polyline-choose-bg' : 'route-polyline-name-bg']"
                class="route-polyline-name">{{ routes[index].name }}
              </div>
            </el-amap-marker>
          </el-amap>
        </div>

        <div style="position: fixed;top: 20px;right: 20px;background-color: #fff;border-radius: 8px;padding: 12px;"
          v-if="status == 2">
          <div style="background-color: #ecf5ff;border-radius: 8px;padding: 12px;display: flex;flex-direction: row;">
            <i class="el-icon-warning" style="color: #2979ff;"></i>
            <div style="font-size: 12px;color: #333;margin-left: 8px;">
              <div>请按如下步骤操作：</div>
              <div>路线编辑时,点击下面可切换画框操作的效果</div>
              <div>新建路线时,按任Ctrl画框选点进行新增或移除</div>
              <div>编辑路线时,按任Ctrl画框选点进行新增或移除</div>
            </div>
          </div>
          <div style="margin-top: 12px;display: flex;flex-direction: row;justify-content: flex-end;">
            <el-radio-group v-model="action" size="mini">
              <el-radio-button label="1">新增</el-radio-button>
              <el-radio-button label="2">移除</el-radio-button>
            </el-radio-group>
          </div>
        </div>


        <!--        <div style="position: fixed;bottom: 20px;left: 600px;">-->
        <!--          <div-->
        <!--            style="display: flex;flex-direction: row;border: 1px solid #f3f4f6;border-radius: 8px;padding: 4px 8px;background-color: #fff;">-->
        <!--            <el-checkbox label="地点名称" size="mini"-->
        <!--              style="background-color: #fff;margin: 0;padding: 4px 8px;"></el-checkbox>-->
        <!--            <el-checkbox label="路线名称" size="mini"-->
        <!--              style="background-color: #fff;margin: 0;padding: 4px 8px;"></el-checkbox>-->
        <!--            <el-checkbox label="路线范围" size="mini"-->
        <!--              style="background-color: #fff;margin: 0;padding: 4px 8px;"></el-checkbox>-->
        <!--            <el-checkbox label="悬浮展示" size="mini"-->
        <!--              style="background-color: #fff;margin: 0;padding: 4px 8px;"></el-checkbox>-->
        <!--          </div>-->
        <!--        </div>-->

      </el-main>
    </el-container>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import { GetAllTeamPlaceList, GetRoutePlanNeedPlace, SearchAddress } from '../api/place.js'
import {
  DeleteRoute, GetHDGRoutePlaces,
  GetHDGTeamTodayRoutes,
  GetRoutePlace,
  GetRoutePlaces,
  SaveRoute, SetRouteUser,
  UpdateHDGRoute
} from '../api/route.js'
import * as turf from '@turf/turf'
import { GetTeamUser } from '../api/personnel'
import { throttle } from '../utils/utils'

export default {
  name: 'Plan',
  components: { Menu },
  data() {
    return {
      checkboxGroup1: [],
      mapConf: {
        mouseTool: null,
        center: [],
        zooms: [3, 19],
        mapStyle: 'normal',
        map: null,
        markerIcon: {},
        routeIndex: null,
        polygon: {
          draggable: false,
          visible: true,
          edit: true,
          path: [],
        }
      },
      routeConf: {
        index: null,
        showPlaceIndex: null,
      },
      popoverConf: {
        visible: false,
        user_id: null,
        route_id: null,
      },
      action: 1,// 1-新增 2-移除
      collapseIndex: [],
      routePolylines: [],
      routePolygons: [],
      routeMarkers: [],
      routePlaces: [],
      routeGoods:[],
      newRouteGoods:[], // 新建应用时展示的商品信息
      routePlaceNo: [],
      routePolygonConf: {
        strokeWeight: 6,
        borderWeight: 1,
        fillOpacity: 0.3,
        checked: {
          strokeColor: '#2979ff'
        },
        unchecked: {
          strokeColor: '#bdbbbb'
        }
      },
      routePolylineConf: {
        strokeWeight: 6,
        borderWeight: 1,
        checked: {
          strokeColor: '#2979ff'
        },
        unchecked: {
          strokeColor: '#bdbbbb'
        }
      },
      routeMarkerConf: {
        checked: {
          bgColor: '#2979ff',
        },
        unchecked: {
          bgColor: '#bdbbbb',
        }
      },
      routeCenterPoints: [],
      originIndex: '',
      origin_keyword: '', // 起点搜索关键字
      details: {}, // 路线详情页面
      placeList: [], // 团队所有地点列表
      routeReq: { // 路线规划请求参数
        id: null,
        name: '',
        user_id: null,
        mode: 1,
        strategy: 1,
        route_type: 1,
      },
      updateReq: {
        delPlaceId: [],
      },
      overConf: {
        routePlaceId: 0,
        placeId: 0,
        status: false,
      },
      waypointConf: {
        props: { multiple: true },
        options: []
      },
      placeIds: [],
      placeIndexs: [],
      placeMarkers: [],
      route: [
        '/static/images/route/route-set/0-select.png',
        '/static/images/route/route-set/1.png',
        '/static/images/route/route-set/2.png',
      ],
      route_not_select: [
        '/static/images/route/route-set/0.png',
        '/static/images/route/route-set/1.png',
        '/static/images/route/route-set/2.png',
      ],
      route_select: [
        '/static/images/route/route-set/0-select.png',
        '/static/images/route/route-set/1-select.png',
        '/static/images/route/route-set/2-select.png',
      ],
      id: [51526, 51528, 51546],
      routes: [],
      userList: [],
      hoverTimer: null,
      isCtrlPressed: false,
      showMap: false,
      status: 0, // 0-路线列表 1-路线详情 2-新建路线
    }
  },
  mounted() {
    this.getTeamPlaceList()
    this.getPlaceSelectOptions()
    this.getTeamUser()
  },
  methods: {
    initMap(e) {
      this.mapConf.mouseTool = new AMap.MouseTool(e)
      this.mapConf.mouseTool.on('draw', this.drawOverlays)
      this.mapConf.map = e
      // 添加全局事件监听
      document.addEventListener('keydown', this.handleKeyDown)
      document.addEventListener('keyup', this.handleKeyUp)
    },
    handleKeyDown(e) {
      if (this.status != 2) {
        return false
      }
      if (e.ctrlKey && !this.isCtrlPressed) {
        this.isCtrlPressed = true
        // 开始绘制多边形（或其他矢量图形）
        this.mapConf.mouseTool.rectangle({
          fillColor: '#2979ff',
          strokeColor: '#ecf5ff'
          //同Polygon的Option设置
        })
      }
    },
    handleKeyUp(e) {
      if (this.status != 2) {
        return false
      }
      if (!e.ctrlKey && this.isCtrlPressed) {
        this.isCtrlPressed = false
        // 结束绘制
        this.mapConf.mouseTool.close(true)
      }
    },
    newRouteMapHandle(rectangle) {
      let list = this.placeMarkers
      let action = this.action
      let status = this.status
      // 团队地点操作
      for (let i = list.length - 1; i >= 0; i--) {
        let val = list[i]
        let location = [list[i].locations.longitude, list[i].locations.latitude]
        if (rectangle.contains(location)) {
          if (action == 1) {
            this.addPlaceId(val.id)
          } else if (action == 2) {
            this.delPlaceId(val.id)
          }
        }
      }
      this.formatPlaceMarkers()
      this.formatPlaceIdsToPlaceIndex()
      this.formatNewRouteGoods()
    },
    updateRouteMapHandle(rectangle) {
      let list = this.placeMarkers
      let routeIndex = this.routeConf.index
      let routePlaces = this.routeMarkers[routeIndex].slice()
      let action = this.action
      let delRoutePlaceId = []
      let delPlaceId = []
      let delPlaceNo = []
      let hasUpdate = false

      // 对路线地点只进行删除操作
      for (let i = routePlaces.length - 1; i >= 0; i--) {
        let val = routePlaces[i]
        let location = [val.locations.longitude, val.locations.latitude]
        if (rectangle.contains(location)) {
          if (action == 2) {
            hasUpdate = true
            routePlaces.splice(i, 1)
            let routeExists = this.routePlaces[routeIndex].some(obj => obj.no === val.no);
            delPlaceNo.push(val.no)
            if (routeExists) { // 路线本身的地点，记录要删除的路线地点id
              delRoutePlaceId.push(val.id)
            } else { // 不属于路线的地点 所以只需要从已选择id移除
              delPlaceId.push(val.id)
            }
          }
        }
      }

      // 团队地点操作：只进行新增
      for (let i = list.length - 1; i >= 0; i--) {
        let val = list[i]
        let location = [list[i].locations.longitude, list[i].locations.latitude]
        if (rectangle.contains(location)) {
          if (action == 1) {
            hasUpdate = true
            this.addPlaceId(val.id)
            routePlaces.push(val)
            this.routePlaceNo.push(val.no)
          }
        }
      }

      if (hasUpdate) {
        if (routePlaces.length < 1) {
          this.$notify({
            title: '警告',
            type: 'warning',
            message: '地点少于1个地点'
          })
          return false;
        }
        for (let i = 0; i < delPlaceNo.length; i++) {
          this.delRoutePlaceNo(delPlaceNo[i])
        }
        for (let i = 0; i < delPlaceId.length; i++) {
          this.delPlaceId(delPlaceId[i])
        }
        if (delRoutePlaceId.length > 0) {
          this.updateReq.delPlaceId.push(delRoutePlaceId)
        }
        this.routeMarkers[routeIndex] = routePlaces
        this.formatPlaceMarkers()
        this.formatRouteGoods(routeIndex)
        this.formatRoutePolyline(routeIndex, routePlaces)
        this.$forceUpdate()
      }

    },
    drawOverlays(e) {
      let status = this.status
      if (status != 2) {
        return false
      }
      if (e.obj.CLASS_NAME == 'Overlay.Rectangle') {
        let rectangle = e.obj
        if (this.routeReq.id > 0) {
          this.updateRouteMapHandle(rectangle)
        } else {
          this.newRouteMapHandle(rectangle)
        }
      }
    },
    getTeamUser() {
      let that = this
      GetTeamUser().then(res => {
        if (res.code === 200) {
          this.userList = res.data.list
        }
      })
    },
    markerOverHandle(id, type) {
      let that = this
      if (type == 1) {
        that.overConf.routePlaceId = id
        that.overConf.placeId = 0
      } else if (type == 2) {
        that.overConf.routePlaceId = 0
        that.overConf.placeId = id
      }
    },
    handleMouseOver(id, type) {
      let that = this
      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(function () {
        that.markerOverHandle(id, type)
      }, 500)
    },
    handleMouseLeave() {
      this.overConf.placeId = 0
      this.overConf.routePlaceId = 0
      clearTimeout(this.hoverTimer)
      this.$forceUpdate()
    },
    setRouteUser() {
      let params = {
        user_id: this.popoverConf.user_id,
        route_id: this.popoverConf.route_id
      }
      SetRouteUser(params).then(res => {
        if (res.code == 200) {
          this.popoverConf.route_id = null
          this.popoverConf.user_id = null
          this.$notify({
            type: 'success',
            message: '设置成功'
          })
          this.getRoutes()
        } else {
          this.$notify({
            title: '错误',
            type: 'error',
            message: res.message
          })
        }
      })
    },
    showUserPopover(index) {
      console.log(index)
      let info = this.routes[index]
      this.popoverConf.user_id = info.user_id
      this.popoverConf.route_id = info.id
      this.popoverConf.visible = true
      this.$forceUpdate()
    },
    markerOver(id, type) {
      let that = this
      console.log('start')
      throttle(function () {
        console.log('ok')
        that.markerOverHandle(id, type)
      }, 100)
    },
    commandValue(command, index) {
      return {
        command: command,
        index: index
      }
    },
    // 路线操作
    handleCommand(e) {
      console.log(e)
      let { command, index } = e
      let info = this.routes[index]
      if (command == 'delete') {
        this.deleteRoute(index)
      } else if (command == 'update') {
        this.updateRoute(index)
      }
    },
    markerClickHandle(index) {
      let list = this.placeList
      let info = list[index]
      if (this.status == 2) {
        this.changePlaceId(info.id)
        this.formatPlaceIdsToPlaceIndex()
      }
    },
    addPlaceId(id) {
      let ids = this.placeIds
      let idKey = ids.indexOf(id)
      if (idKey == -1) {
        ids.push(id)
        this.placeIds = ids
        this.$forceUpdate()
      }
    },
    delRoutePlaceNo(no) {
      let nos = this.routePlaceNo
      let idKey = nos.indexOf(no)
      if (idKey !== -1) {
        nos.splice(idKey, 1)
        this.routePlaceNo = nos
        this.$forceUpdate()
      }
    },
    delPlaceId(id) {
      let ids = this.placeIds
      let idKey = ids.indexOf(id)
      if (idKey !== -1) {
        ids.splice(idKey, 1)
        this.placeIds = ids
        this.$forceUpdate()
      }
    },
    // 处理地点id集合，入参要处理的地点id
    changePlaceId(id) {
      let ids = this.placeIds
      let idKey = ids.indexOf(id)
      if (idKey == -1) {
        ids.push(id)
      } else {
        ids.splice(idKey, 1)
      }
      this.placeIds = ids
      this.$forceUpdate()
    },
    // 将处理好的地点集合转格式化为多选框的数据格式
    formatPlaceIdsToPlaceIndex() {
      let placeIndex = []
      let list = this.placeList
      let ids = this.placeIds
      for (let i = 0; i < list.length; i++) {
        if (ids.includes(list[i].id)) {
          if (list[i].district === '') {
            this.placeList[i].district = '其它'
          }
          placeIndex.push([list[i].district, list[i].id])
        }
      }
      this.placeIndexs = placeIndex
      this.$forceUpdate()
    },
    getLocation(e) {
      console.log(e)
    },
    clickMap() {
      if (this.status == 0) {
        this.routeConf.showPlaceIndex = null
        this.routeConf.index = null
      }
    },
    goBack() {
      if (this.routeReq.id > 0) {
        this.clearMap()
        this.getRoutes()
      }
      this.status = 0
      this.clearRouteReq()
    },
    getRouteDetails(index) {
      let info = this.routes[index]
      let params = {
        route_id: info.id
      }
      return GetHDGRoutePlaces(params).then(res => {
        if (res.code == 200) {
          let {list,goods} = res.data
          this.routeGoods[index] = goods
          this.routePlaces[index] = list
          this.routeMarkers[index] = list
          this.formatRoutePolyline(index, list)
          this.formatRoutePlaceNo(list)
        }
      })
    },
    formatRoutePlaceNo(list) {
      for (let i = 0; i < list.length; i++) {
        this.routePlaceNo.push(list[i].no)
      }
    },
    formatRouteCenterPoint(index, location) {
      if(location.length <= 2 ) {
        this.routeCenterPoints[index] = location[0]
        return
      }
      location.push(location[0])
      let list = []
      for (let i = 0; i < location.length; i++) {
        let lng = parseFloat(location[i][0])
        let lat = parseFloat(location[i][1])
        list.push([lng, lat])
      }
      let polygon = turf.polygon([list])
      let centroid = turf.centroid(polygon)
      this.routeCenterPoints[index] = centroid.geometry.coordinates
    },
    formatRoutePolyline(index, list) {
      let polyline = []
      for (let i = 0; i < list.length; i++) {
        let location = list[i].location.split(',')
        polyline.push(location)
      }
      console.log(polyline)
      if(list.length >= 3 ) {
        this.formatRoutePolygon(index, polyline)
      }
      this.formatRouteCenterPoint(index, polyline)
      this.routePolylines[index] = polyline
    },
    formatRoutePolygon(index, location) {
      let pointsObj = turf.featureCollection([])
      let points = []
      for (let i = 0; i < location.length; i++) {
        points.push(turf.point([location[i][0], location[i][1]]))
      }
      pointsObj.features = points
      let hull = turf.convex(pointsObj)
      let polygon = []
      if (hull == null) {
        this.routePolygons[index] = []
      } else {
        polygon = hull.geometry.coordinates[0]
        this.routePolygons[index] = polygon
      }
    },
    chooseRoute(index) {
      if (this.status == 2) {
        return false;
      }
      this.routeConf.index = index
      this.routeConf.showPlaceIndex = null
      this.collapseIndex.push(index)
      this.status = 0
      this.$forceUpdate()
    },
    getRoutes() {
      let that = this
      GetHDGTeamTodayRoutes().then(res => {
        if (res.code == 200) {
          let list = res.data.list
          this.routes = list
          // 创建一个包含所有Promise的数组
          let promises = list.map((_, index) => this.getRouteDetails(index))

          // 使用Promise.all等待所有Promise完成
          Promise.all(promises).then(() => {
            that.formatPlaceMarkers()
          })
        }
      })
    },
    newRoute() {
      this.routeConf.index = null
      this.clearRouteReq()
      this.status = 2
      this.$forceUpdate()
    },
    getTeamPlaceList() {
      GetAllTeamPlaceList().then(res => {
        if (res.code === 200) {
          this.placeList = res.data.list
          this.getRoutes()
        } else {
          this.$notify({
            title: '错误',
            type: 'error',
            message: res.message
          })
        }
      })
    },
    formatNewRouteGoods(){
      let ids = this.placeIds
      let list = this.placeList
      let goodsMap = {}
      for (let i =0;i<list.length;i++){
        let val = list[i]
        if(val.remarks != "" && ids.indexOf(val.id) != -1) {
          let data = this.parseGoods(val.remarks)
          for (let j =0;j<data.length;j++){
            let goodsInfo = data[j]
            if(goodsInfo.name in goodsMap) {
              goodsMap[goodsInfo.name] += parseInt(goodsInfo.number)
            } else {
              goodsMap[goodsInfo.name] = parseInt(goodsInfo.number)
            }
          }
        }
      }
      let routeGoods = []
      for (let name in goodsMap) {
        routeGoods.push({
          name:name,
          number:goodsMap[name]
        })
      }
      this.newRouteGoods = routeGoods
    },
    formatRouteGoods(index){
      let list = this.routeMarkers[index]
      let goodsMap = {}
      for (let i =0;i<list.length;i++){
        let info = list[i]
        console.log(list)
        if("route_id" in info) {
          for (let j =0;j<info.goods.length;j++){
            let goodsInfo = info.goods[j]
            if(goodsInfo.name in goodsMap) {
              goodsMap[goodsInfo.name] += parseInt(goodsInfo.number)
            } else {
              goodsMap[goodsInfo.name] = parseInt(goodsInfo.number)
            }
          }
        } else if (info.remarks != "") {
          let data = this.parseGoods(info.remarks)
          for (let j =0;j<data.length;j++){
            let goodsInfo = data[j]
            if(goodsInfo.name in goodsMap) {
              goodsMap[goodsInfo.name] += parseInt(goodsInfo.number)
            } else {
              goodsMap[goodsInfo.name] = parseInt(goodsInfo.number)
            }
          }
        }
      }
      let routeGoods = []
      for (let name in goodsMap) {
        routeGoods.push({
          name:name,
          number:goodsMap[name]
        })
      }
      this.routeGoods[index] = routeGoods
    },
    parseGoods(input){
      if (input == "") {
        return []
      }
      let resp = []
      let splits = input.split(';')
      for (let i = 0;i<splits.length;i++){
        let info = splits[i]
        if (info != "") {
          let data = info.split(':')
          if (data.length == 2) {
            resp.push({
              name:data[0],
              number:data[1]
            })
          }
        }
      }
      return resp
    },
    formatPlaceMarkers() {
      let list = this.placeList
      let no = this.routePlaceNo
      let markers = []
      for (let i = 0; i < list.length; i++) {
        if (!no.includes(list[i].no)) {
          markers.push(list[i])
        }
      }
      this.placeMarkers = markers
      this.$forceUpdate()
    },
    getPlaceSelectOptions() {
      let that = this
      GetRoutePlanNeedPlace().then(res => {
        if (res.code === 200) {
          that.waypointConf.options = res.data.list
        } else {
          that.$notify({
            title: '错误',
            type: 'error',
            message: res.message
          })
        }
      })
    },
    // 刷新途经点选项
    refreshWayPlace(locationArr) {
      let index = []
      let idArr = []
      for (let i = 0; i < this.placeList.length; i++) {
        if (locationArr.includes(this.placeList[i].location)) {
          if (this.placeList[i].district === '') {
            this.placeList[i].district = '其它'
          }
          index.push([this.placeList[i].district, this.placeList[i].id])
          idArr.push(this.placeList[i].id)
        }
      }
      this.routeReq.ids = idArr.join(',')
      this.placeIndexs = index
    },
    formatPlaceIndexToIds() {
      let ids = []
      let index = this.placeIndexs
      for (let i = 0; i < index.length; i++) {
        ids[i] = index[i][1]
      }
      return ids
    },
    placeChangeHandle() {
      let that = this
      this.placeIds = this.formatPlaceIndexToIds()
    },
    clearMap() {
      this.routePolygons = []
      this.routePolylines = []
      this.routeMarkers = []
      this.routeCenterPoints = []
      this.routePlaceNo = []
      this.routes = []
    },
    updateRoute(index) {
      let info = this.routes[index]
      this.status = 2
      this.routeConf.index = index
      this.routeReq = {
        id: info.id,
        name: info.name,
        user_id: info.user_id
      }
    },
    deleteRoute(index) {
      let info = this.routes[index]
      let params = {
        route_id: info.id
      }
      DeleteRoute(params).then(res => {
        if (res.code == 200) {
          this.$notify({
            type: 'success',
            message: '删除成功',
          })
          this.clearMap()
          this.getRoutes()
        } else {
          this.$notify({
            title: '错误',
            type: 'error',
            message: res.message
          })
        }
      })
    },
    submitUpdateRoute() {
      let routeReq = this.routeReq
      let params = {
        id: routeReq.id,
        name: routeReq.name,
        user_id: routeReq.user_id,
        add_place_id: this.placeIds.join(','),
        del_place_id: this.updateReq.delPlaceId.join(',')
      }
      UpdateHDGRoute(params).then(res => {
        if (res.code === 200) {
          this.status = 0
          this.clearRouteReq()
          this.$notify({
            type: 'success',
            message: '路线修改成功',
          })
          this.clearMap()
          this.getRoutes()
        } else {
          this.$notify({
            title: '错误',
            type: 'error',
            message: res.message
          })
        }
      })
    },
    submitRoute() {
      if (this.routeReq.id > 0) {
        this.submitUpdateRoute()
      } else {
        this.saveRoute()
      }
    },
    saveRoute() {
      let that = this
      let params = {
        name: this.routeReq.name,
        user_id: this.routeReq.user_id,
        ids: this.placeIds.join(','),
      }
      SaveRoute(params).then(res => {
        if (res.code === 200) {
          this.clearRouteReq()
          this.$notify({
            type: 'success',
            message: '路线保存成功',
          })
          this.getRoutes()
        } else {
          this.$notify({
            title: '错误',
            type: 'error',
            message: res.message
          })
        }
      })
    },
    clearRouteReq() {
      this.placeIds = []
      this.placeIndexs = []
      this.routeReq.user_id = null
      this.routeReq.name = ''
      this.routeReq.id = null
      this.newRouteGoods = []
    }
  }
}
</script>

<style scoped>
.route-list {
  padding-top: 12px;
  flex: 1;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.route-list::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, and Opera */
}

.route-place-list-div {
  height: 60vh;
  margin-left: 42px;
  display: flex;
  flex-direction: column;
}

.route-place-list {
  margin-top: 4px;
  overflow: auto;
  flex: 1;
  height: 100%;
}

.route-form-place-list {
  overflow: auto;
  flex: 1;
}

.route-form-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.route-choose {
  background-color: #d4e5f6;
}

.route-not-choose {
  background-color: #f3f4f6;
}

.route-info {
  padding: 6px 12px;
  border-radius: 4px;
  flex: 1;
}

.route-polyline-choose-bg {
  background-color: #2979ff;
}

.route-polyline-name-bg {
  background-color: #999999;
}

.route-polyline-name {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  color: #fff;
}

.number-details {
  width: 96%;
  margin: 20px auto;
  height: 150px;
  box-shadow: 0 0 10px 0 rgb(42 60 89/16%);
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.number-details .number-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.number-item .number-num {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}

.number-item .number-label {
  font-size: 12px;
  color: #808695;
  margin-top: 2px;
}

.route-place-sort {
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  text-align: center;
  line-height: 20px;
  color: #fff;
  border: 2px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/Plan.vue